var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.38035 0.880005H2.41716C2.18917 0.880005 1.97051 0.970575 1.80929 1.13179C1.64808 1.29301 1.55751 1.51166 1.55751 1.73966C1.55751 1.96765 1.64808 2.18631 1.80929 2.34752C1.97051 2.50874 2.18917 2.59931 2.41716 2.59931H7.30429L0.262442 9.64201C0.180336 9.72132 0.114846 9.81617 0.0697925 9.92105C0.024739 10.0259 0.00102434 10.1387 3.24577e-05 10.2529C-0.000959424 10.367 0.0207913 10.4802 0.0640154 10.5859C0.107239 10.6915 0.171071 10.7875 0.251786 10.8682C0.332502 10.9489 0.428483 11.0128 0.534131 11.056C0.63978 11.0992 0.752978 11.121 0.867123 11.12C0.981267 11.119 1.09407 11.0953 1.19895 11.0502C1.30383 11.0052 1.39869 10.9397 1.47799 10.8576L8.52069 3.81529V8.70284C8.52069 8.93084 8.61126 9.14949 8.77248 9.31071C8.9337 9.47193 9.15235 9.5625 9.38035 9.5625C9.60834 9.5625 9.827 9.47193 9.98821 9.31071C10.1494 9.14949 10.24 8.93084 10.24 8.70284V1.73966C10.24 1.51166 10.1494 1.29301 9.98821 1.13179C9.827 0.970575 9.60834 0.880005 9.38035 0.880005Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow.480abd2873351f43c41d00465222fed5.svg";